import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import ChipEdit from 'ChipEdit';
import Chip from 'Chip';
import transform from 'chipDataTransform';
import Ad from '@ifeng-fe/ui_pc_ad';
import styles from './index.css';
import Nav from './nav';
import HtmlRegion from '../../components/htmlRegion';
import Slide from '../components/slide';
import NewsStream from './newsStream';
import Footer from './footer';
import ScrollDisplay from '../../gongyiListpage/components/scrollDisplay';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;
        const navData = {
            channel: content.channel,
            topnav: content.topnav,
        };
        const newsStreamData = {
            isEnd: content.isEnd,
            newsstream: content.newsstream,
            columnId: content.columnId,
        };
        const footerData = {
            footer: content.footer,
            introduction: content.introduction,
            introductionId: content.introductionId,
        };

        return (
            <Fragment>
                <ChipEdit transform={transform} />
                <Ad styleName={styles.headAd} content={content.headAd} />
                <Nav content={navData} />
                <Chip id={content.logoId} type="static" title="logo" groupName="logo" content={content.logo}>
                    <HtmlRegion className={styles.logo} />
                </Chip>
                <div className={styles.slide}>
                    <Chip id={content.slideId} type="recommend" title="轮播" groupName="轮播" content={content.slide}>
                        <Slide />
                    </Chip>
                </div>
                <NewsStream content={newsStreamData} />
                <Footer content={footerData} />
                <ScrollDisplay>
                    <Chip id="30023" type="static" title="二维码" groupName="二维码" content={content.floatQrcode}>
                        <HtmlRegion />
                    </Chip>
                </ScrollDisplay>
            </Fragment>
        );
    }
}

export default Layout;
